<template>
  <v-container class="d-flex justify-center flex-wrap">
    <v-dialog width="300" v-model="changeDlg" persistent>
      <v-card>
        <v-card-title>Cambiar contraseña</v-card-title>
        <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="changePassword">
          <v-card-text>
            <v-text-field
              v-model="passwords.actual"
              type="password"
              label="Contraseña actual"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="passwords.nueva"
              label="Nueva Contraseña"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              :rules="[rules.required, rules.min]"
              @click:append="show = !show"
            ></v-text-field>
            <PasswordIndicator :pass="passwords.nueva" />
            <v-text-field
              v-model="passwords.confirmar"
              type="password"
              label="Confirmar nueva contraseña"
              :rules="[rules.required, rules.match(passwords.nueva, passwords.confirmar)]"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" small type="submit" :disabled="!valid">Cambiar</v-btn>
            <v-btn color="error" small @click="passwords = {}; changeDlg = false">Cancelar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-list>
      <v-list-item class="mb-3">
        <v-list-content>
          <v-list-title class="title">Seguridad y datos</v-list-title>
        </v-list-content>
      </v-list-item>
      <v-list-item>
        <v-list-content>
          <v-card width="600">
            <v-card-text>
              <v-list two-lines>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-img src="@/assets/icon2.jpg"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Clave</v-list-item-title>
                    <v-list-item-subtitle>Podrás cambiar la clave de acceso a tu cuenta</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-btn color="primary" outlined small @click="changeDlg = true">Cambiar</v-btn>
                </v-list-item>
                <v-divider class="my-3"></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-img src="@/assets/icon2.jpg"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Autenticación Multifactor</v-list-item-title>
                    <v-list-item-subtitle>Podrás agregar un nivel extra de seguridad</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-btn color="primary" outlined small @click="activate2FA">
                    {{
                    multiAuth ? 'Desactivar':'Activar'
                    }}
                  </v-btn>
                </v-list-item>
                <v-divider class="my-3"></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-img src="@/assets/icon1.png"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Datos</v-list-item-title>
                    <v-list-item-subtitle>Podras cambiar tus datos personales</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-btn color="primary" outlined small>Cambiar</v-btn>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-list-content>
      </v-list-item>
    </v-list>

    <v-dialog width="500" v-model="authQR" persistent>
      <v-card>
        <v-card-title>¡Two-Factor Authentication aumenta la seguridad de tu cuenta en smartchronos!</v-card-title>
        <v-card-content>
          <p>Todo lo que necesitas es un app compatible en tu navegador o teléfono, las más usadas son:</p>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Google Authenticator</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Duo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Authy</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <qrcode v-if="auth2FA" :value="auth2FA"></qrcode>
          <p>Escanea esta imagen con tu app. Obtendrás un código de 6 dígitos el cual te será pedido para completar el inicio de tus sesiones.</p>
        </v-card-content>
        <v-card-actions>
          <v-btn color="primary" small type="submit" @click="authQR = false">Hecho</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { API } from "../../globals";
import { Auth } from "../../classes/Auth";
import { apiv1 } from "../../libs/apiv1";
import PasswordIndicator from "@/components/PasswordIndicator";

const auth = new Auth();

export default Vue.extend({
  name: "CambiarClave",
  components:{
    PasswordIndicator
  },
  data: () => ({
    valid: true,
    changeDlg: false,
    passwords: {},
    rules: {
      required: value => !!value || "Por favor diligencie este campo",
      min: v => v.length >= 8 || "Min 8 characters",
      match: (pass, confirm) =>
        pass === confirm || "Las contraseñas deben coincidir"
    },
    errors: [],
    authQR: false,
    multiAuth: false,
    show: false
  }),
  mounted(){
    const { multiAuth } = auth.getUser();
    this.multiAuth = multiAuth;
  },
  methods: {
    changePassword: function() {
      if (this.$refs.form.validate()) {
        const { confirmar, nueva } = this.passwords;
        if (nueva !== confirmar) {
          return this.$awn.warning("Las contraseñas no coinciden");
        }
        const { id } = auth.getUser();

        let url = `user/change-password/${id}`;
        if (auth.isVertebra()) {
          url += `?type=VERTEBRA`;
        }

        apiv1({
          method: "PUT",
          url: url,
          data: this.passwords
        })
          .then(res => {
            this.changeDlg = false;
            this.passwords = {};
            this.$awn.success(res.data);
            if (!auth.getProject()) {
              this.$router.push("/choose-project");
            }
          })
          .catch(err => this.$awn.alert(err.response.data));
      }
    },
    activate2FA() {
      const { id } = auth.getUser();
      if (this.multiAuth){
        apiv1({
          method: "POST",
          url: `deactivate2fa`,
          data: { user_id: id, isAdmin: auth.isVertebra()}
        })
          .then(res => {
            console.log(res.data);
            this.$awn.success(res.data);
            this.multiAuth = false;
          })
          .catch(err => this.$awn.alert(err));
      }
      else{

        apiv1({
          method: "POST",
          url: `generate2fa`,
          data: { user_id: id, isAdmin: auth.isVertebra()}
        })
          .then(res => {
            console.log(res.data.payload);
            this.auth2FA = res.data.payload;
            this.authQR = true;
            this.multiAuth = true;
          })
          .catch(err => this.$awn.alert(err));
      }
    }
  }
});
</script>

<style>
</style>